import BasicButton from '../../../../../../Shared/Ui/Buttons/BasicButton/BasicButton';
import css from './DeleteProjectWarningModal.module.css';
import classNames from 'classnames';
import React from 'react';
import { BasicModal } from '@shared/Widgets/Modals/BasicModal/BasicModal';

interface DeleteProjectWarningModalProps {
    onClose?: () => void;
    onConfirm?: () => void;
    projectTitle?: string;
}

export const DeleteProjectWarningModal: React.FC<
    DeleteProjectWarningModalProps
> = ({ onClose, projectTitle, onConfirm }) => {
    return (
        <BasicModal onClose={onClose} extraClassName={css.modal}>
            <div className={css.content}>
                <span className={css.warning}>
                    Are you sure you want to delete project "{projectTitle}"?
                </span>
            </div>
            <div className={css.btns}>
                <BasicButton
                    extraClassName={classNames(css.btn, css.cancel)}
                    onClick={onClose}
                >
                    CANCEL
                </BasicButton>

                <BasicButton extraClassName={css.btn} onClick={onConfirm}>
                    CONFIRM
                </BasicButton>
            </div>
        </BasicModal>
    );
};
